import React, { useContext, useState } from "react";

import { APIContext, PopUpContext } from "../../API";

import { Status, StatusButton } from "../misc";
import DemoForm from "./DemoForm";
import DemoRow from "./DemoRow";
import DeleteDemo from "./DeleteDemo";

export default function EditDemos(props) {
  const API = useContext(APIContext);
  const { setPopUp } = useContext(PopUpContext);

  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);
  const [progress, setProgress] = useState(null);

  function audioSelectHandler(e) {
    setError(null);

    if (e.target.files[0]) {
      if (e.target.files[0].type.substring(0, 5) !== "audio") {
        return setError("Invalid demo file type.");
      }

      props.setNewDemo({
        name: e.target.files[0].name.split(".")[0],
        audio: e.target.files[0],
      });
    }
  }

  function addDemo() {
    setError(null);

    if (!props.newDemo) {
      return setError("Missing Demo");
    } else if (props.newDemo.name === "") {
      return setError("Missing Demo Name");
    }

    setStatus("Uploading");
    API.addDemo(props.product, props.newDemo, setProgress, (err, response) => {
      setProgress(null);
      setStatus(null);
      if (err) {
        return setError(err.response?.data?.msg || "Something went wrong");
      }
      props.close && props.close();
    });
  }

  function removeDemo(i) {
    setPopUp({
      title: "Delete Demo",
      component: () => (
        <DeleteDemo
          product={props.product}
          demo={props.demos[i]}
          close={props.close}
        />
      ),
    });
  }

  return (
    <>
      <h2 className="mb-2">Edit Demos</h2>
      <DemoForm
        demos={props.demos}
        removeDemo={removeDemo}
        onChange={!props.newDemo && audioSelectHandler}
      />
      {props.newDemo && (
        <div className="demo-form">
          <DemoRow
            index={props.demos.length + 1}
            demo={props.newDemo}
            setName={(name) => props.setNewDemo({ ...props.newDemo, name })}
            removeDemo={() => props.setNewDemo(null)}
          />
          <Status error={error} progress={progress} />
          <StatusButton
            text="Submit"
            status={status}
            className="button"
            onClick={addDemo}
          />
        </div>
      )}
    </>
  );
}
